export const CurrentTimeStamp = () => (
  <div className='time_tag hidden h-10 text-xl mx-auto'>
    {new Date().toISOString()}
  </div>
);
